import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import { ChakraProvider } from "@chakra-ui/react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import AppRouter from "./config/router/router";
import Montserrat from "./assets/fonts/Montserrat.ttf";
import { store } from "./store/store";
import theme from "./Chakratheme.js";

/**
 * Main App component that sets up providers:
 * - Redux store provider
 * - Chakra UI theme provider
 * - Ant Design config provider
 * - React DnD provider
 */
function App() {
  return (
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#E2B024",
              fontFamily: Montserrat,
            },
          }}
        >
          <DndProvider backend={HTML5Backend}>
            <AppRouter />
          </DndProvider>
        </ConfigProvider>
      </ChakraProvider>
    </Provider>
  );
}

export default App;
